import React, { useLayoutEffect, useRef } from 'react'

import { ContentProps } from '../../../renderer'
import { TypeComponentTextInput } from '../../../../lib/types/component-text-input'
import { TextInput } from '../../../inputs/text-input'

interface ExpandedTextareaProps extends ContentProps<TypeComponentTextInput> {
  isShown?: boolean
  labelClassName?: string
  helperTextClassName?: string
  onPaste?: React.ClipboardEventHandler<HTMLTextAreaElement>
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
  hideErrorText?: boolean
  isDisabled?: boolean
}

export const ExpandedTextarea: React.FC<ExpandedTextareaProps> = ({
  structure,
  isShown,
  className,
  labelClassName,
  helperTextClassName,
  onPaste,
  onChange,
  hideErrorText,
  isDisabled,
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  // Display none causes the height of the textarea to not match the placeholder height upon initial render
  // A re-render based on when the textarea is shown fixes this
  // useLayoutEffect avoids the flicker due to re-render for height change when moving from one step to another
  useLayoutEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px'
    }
  }, [structure.fields.placeholder, isShown])

  return (
    <TextInput
      structure={structure}
      className={className}
      labelClassName={labelClassName}
      helperTextClassName={helperTextClassName}
      hasLongformText={true}
      ref={textAreaRef}
      onPaste={onPaste}
      onChange={onChange}
      hideErrorText={hideErrorText}
      isDisabled={isDisabled}
    />
  )
}
